import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import Image from '../../components/Image/Image.js';
import styles from './PinCode.module.scss.js';
import img from './users_pin.png.js';

var SuccessPinCode = function SuccessPinCode(_ref) {
  var userName = _ref.userName,
    showReminder = _ref.showReminder;
  return /*#__PURE__*/React.createElement("section", {
    className: styles.startStep
  }, /*#__PURE__*/React.createElement(Image, {
    url: img,
    className: styles.img
  }), /*#__PURE__*/React.createElement("section", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("p", null, " ", t('MPLIB_PIN_SUCCESSFUL_DESCRIPTION', {
    userName: userName
  }))), showReminder && /*#__PURE__*/React.createElement("section", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("p", null, " ", t('MPLIB_PIN_SUCCESSFUL_REMINDER'))));
};
SuccessPinCode.propTypes = {
  userName: PropTypes.string.isRequired,
  showReminder: PropTypes.bool
};
SuccessPinCode.defaultProps = {
  showReminder: false
};

export { SuccessPinCode as default };
